/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createLoyaltyAccount} from '../api'

export const useMutationCreateLoyaltyAccount = createReactQueryMutationHook('createLoyaltyAccount', createLoyaltyAccount)
